import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SystemUser} from '../models/system-user.model';
import {OldPasswordResetRequest, ResetPasswordRequest} from '../models/reset-password-request.model';
import {map} from 'rxjs/operators';
import {PasswordPolicy} from '../models/password-policy.model';
import {skipInterceptors} from '../helpers/request.helper';

export const LOGIN_REQUEST_URL = '/api/public/login';

@Injectable()
export class AuthService {
    publicUrl = '/api/public';

    constructor(
        private http: HttpClient
    ) {
    }

    login(username, password) {
        return this.http.post<SystemUser>(LOGIN_REQUEST_URL, {username, password}, {observe: 'response'});
    }

    getCurrentUser() {
        return this.http.get<SystemUser>('/api/secured/user');
    }

    logout() {
        return this.http.put<SystemUser>('/api/secured/logout', {});
    }

    passwordForgotten(username: string) {
        return this.http.post(`${this.publicUrl}/forgot-password`, username);
    }

    passwordReset(token: string, formData: ResetPasswordRequest) {
        return this.http.post(`${this.publicUrl}/reset-password/${token}`, {...formData});
    }

    oldPasswordReset(token: string, formData: OldPasswordResetRequest) {
        return this.http.post(`${this.publicUrl}/reset-old-password/${token}`, {...formData});
    }

    getPasswordPolicy(token: string) {
        const headers: HttpHeaders = skipInterceptors([404]);
        return this.http.get<PasswordPolicy>(`${this.publicUrl}/reset-password/${token}`, {
            headers,
            observe: 'response'
        })
            .pipe(
                map(response => response.body));
    }

}
